

































import { Component, Vue, Mixins } from "vue-property-decorator";
import myMixins from "@/global/mixin";
import { publicNotice } from "@/api/user/user";
import moment from "moment";

@Component
export default class Content extends Mixins(myMixins) {
  private noticeList: object[] = [];
  private total: number = 0;
  private page: number = 1;

  // 切换页面
  private changePage(num) {
    this.page = num;
    this.getNotice();
  }

  private async getNotice() {
    let param = {
      status: 0,
      page: this.page,
    };

    const data: any = await publicNotice(param);
    this.$nextTick(() => {
      if (data.code == "200" && data.result.rows) {
        this.noticeList = data.result.rows;
        this.total = data.result.total;
        this.noticeList.forEach((item, index) => {
          (item as any).time = moment((item as any).time * 1000).format(
            "YYYY-MM-DD"
          );
        });
      }
    });
  }

  private openNotice(item) {
    let userInfo = this.$store.state.userInfo;
    if (!(userInfo && userInfo.id)) {
      this.$Message.error("请登录后查看");
      return;
    }
    if (userInfo.isShowTagger) {
      this.$Message.error("您没有权限查看");
      return;
    }
    if (item.type == 1) {
      window.open(item.message, "_blank");
    }
  }

  private created() {
    this.getNotice();
  }
}
